import { Navigate, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTeamAccess } from "./hooks/useTeamAccess";
import { useUserStore } from "../../store/userStore";

/** A dónde va quien no es dueño: lo que cada colaborador sí viene a ver (#1025). */
export const TEAM_DENIED_REDIRECT = "/payroll/payments";

/**
 * Puerta de `/team/*` (#1145): en CC-CONSOLE solo entran los dueños.
 *
 * Solo se redirige cuando el servidor YA respondió: mientras carga se muestra
 * un aviso de espera, así un dueño no rebota fuera de su app. El mosaico se
 * oculta aparte (useFilteredCategories) y la API responde 403 a los demás; esto
 * cubre a quien escribe la URL a mano o trae un enlace guardado.
 */
export default function TeamOwnersGuard() {
  const { t } = useTranslation("common");
  const user = useUserStore((state) => state.user);
  const access = useTeamAccess();
  // Sin sesión cargada no hay a quién preguntar: TeamLayout manda a /splash y,
  // al volver con sesión, esta puerta decide. (La API igual responde 401/403.)
  if (!user) return <Outlet />;
  if (access === "denied") return <Navigate to={TEAM_DENIED_REDIRECT} replace />;
  if (access === "loading") {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-gray-500" role="status">
        <i className="ri-loader-4-line mr-2 animate-spin" aria-hidden="true" />
        {t("team.ownersOnly.checking")}
      </div>
    );
  }
  return <Outlet />;
}
